module.exports = __webpack_public_path__ + "static/img/event-explore.c7a224e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fullwidth/event-explore.png
// module id = 5xHc
// module chunks = 1